import SyncfusionGrid from "components/custom/Syncfusion/SyncfusionGrid"
import { removePunctuationSigns } from "helpers/objPropsToLowercaseMapper"
import React, { useEffect, useState } from "react"
import { currencyFormatter } from "utils/formatters"

const AlternativeRatingsGrid = ({
  data,
  setData,
  dropdownSelection,
  objectives,
  alternativeName,
  objectivesAndMeasures,
}) => {
  const [columns, setColumns] = useState([])

  useEffect(() => {
    if (dropdownSelection != null) {
      loadColumns()
    }
  }, [dropdownSelection])

  const loadColumns = () => {
    const columns = [
      { field: "alternativenum", headerText: "ID", width: 80, freeze: "Left" },
      {
        field: "alternative",
        headerText: "Name",
        width: 250,
        freeze: "Left",
      },
      {
        field: "version",
        headerText: "Version",
        width: 100,
        freeze: "Left",
        filter: {
          type: "Excel",
          itemTemplate: data => {
            return (
              <div
                style={{ lineHeight: "20px" }}
                dangerouslySetInnerHTML={{
                  __html: data.version,
                }}
              ></div>
            )
          },
        },
        template: data => (
          <div
            style={{ lineHeight: "20px" }}
            dangerouslySetInnerHTML={{
              __html: data.version,
            }}
          ></div>
        ),
      },
    ]

    if (dropdownSelection.value == 0) {
      objectives.forEach(o => {
        columns.push({
          field: removePunctuationSigns(o.objectiveName?.toLowerCase()),
          headerText: o.objectiveName,
          width: 200,

          filter: {
            type: "Excel",
            itemTemplate: data => {
              return (
                <div
                  style={{ lineHeight: "20px" }}
                  dangerouslySetInnerHTML={{
                    __html:
                      data[
                        removePunctuationSigns(o.objectiveName?.toLowerCase())
                      ],
                  }}
                ></div>
              )
            },
          },
          template: data => (
            <div
              style={{ lineHeight: "20px" }}
              dangerouslySetInnerHTML={{
                __html:
                  data[removePunctuationSigns(o.objectiveName?.toLowerCase())],
              }}
            ></div>
          ),
        })
      })
    } else if (dropdownSelection.value == -99) {
      objectivesAndMeasures.forEach(o => {
        if (o.measureID != undefined) {
          columns.push({
            field: removePunctuationSigns(o.measureName?.toLowerCase()),
            headerText: o.measureName,
            width: 200,

            filter: {
              type: "Excel",
              itemTemplate: data => {
                return (
                  <div
                    style={{ lineHeight: "20px" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        data[
                          removePunctuationSigns(o.measureName?.toLowerCase())
                        ],
                    }}
                  ></div>
                )
              },
            },
            template: data => (
              <div
                style={{ lineHeight: "20px" }}
                dangerouslySetInnerHTML={{
                  __html:
                    data[removePunctuationSigns(o.measureName?.toLowerCase())],
                }}
              ></div>
            ),
          })
        } else {
          columns.push({
            field: removePunctuationSigns(o.objectiveName?.toLowerCase()),
            headerText: o.objectiveName,
            width: 200,

            filter: {
              type: "Excel",
              itemTemplate: data => {
                return (
                  <div
                    style={{ lineHeight: "20px" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        data[
                          removePunctuationSigns(o.objectiveName?.toLowerCase())
                        ],
                    }}
                  ></div>
                )
              },
            },
            template: data => (
              <div
                style={{ lineHeight: "20px" }}
                dangerouslySetInnerHTML={{
                  __html:
                    data[
                      removePunctuationSigns(o.objectiveName?.toLowerCase())
                    ],
                }}
              ></div>
            ),
          })
        }
      })
    } else {
      objectivesAndMeasures.forEach(m => {
        if (
          m.measureID != undefined &&
          m.objectiveID == dropdownSelection.value
        ) {
          columns.push({
            field: removePunctuationSigns(m.measureName?.toLowerCase()),
            headerText: m.measureName,
            width: 200,

            filter: {
              type: "Excel",
              itemTemplate: data => {
                return (
                  <div
                    style={{ lineHeight: "20px" }}
                    dangerouslySetInnerHTML={{
                      __html:
                        data[
                          removePunctuationSigns(m.measureName?.toLowerCase())
                        ],
                    }}
                  ></div>
                )
              },
            },
            template: data => (
              <div
                style={{ lineHeight: "20px" }}
                dangerouslySetInnerHTML={{
                  __html:
                    data[removePunctuationSigns(m.measureName?.toLowerCase())],
                }}
              ></div>
            ),
          })
        }
      })
    }

    columns.push({
      field: "saascore",
      headerText: "Benefit Score",
      width: 200,

      filter: {
        type: "Excel",
        itemTemplate: data => {
          return (
            <div
              style={{ lineHeight: "20px" }}
              dangerouslySetInnerHTML={{
                __html: data.saascore,
              }}
            ></div>
          )
        },
      },
      template: data => (
        <div
          style={{ lineHeight: "20px" }}
          dangerouslySetInnerHTML={{
            __html: data.saascore,
          }}
        ></div>
      ),
    })
    columns.push({
      field: "xcost",
      headerText: "Total Cost",
      width: 200,
      textAlign: "Right",
      filter: {
        type: "Excel",
        itemTemplate: data => {
          return currencyFormatter.format(data.xcost)
        },
      },
      template: data => currencyFormatter.format(data.xcost),
    })
    columns.push({
      field: "xcost_project",
      headerText: "Project Cost",
      width: 200,
      textAlign: "Right",
      filter: {
        type: "Excel",
        itemTemplate: data => {
          return currencyFormatter.format(data.xcost_project)
        },
      },
      template: data => currencyFormatter.format(data.xcost_project),
    })
    columns.push({
      field: "saarating",
      headerText: "Group Rating",
      width: 200,

      filter: {
        type: "Excel",
        itemTemplate: data => {
          return (
            <div
              style={{ lineHeight: "20px" }}
              dangerouslySetInnerHTML={{
                __html: data.saarating,
              }}
            ></div>
          )
        },
      },
      template: data => (
        <div
          style={{ lineHeight: "20px" }}
          dangerouslySetInnerHTML={{
            __html: data.saarating,
          }}
        ></div>
      ),
    })
    columns.push({
      field: "saascorenormal",
      headerText: "Normalized Score",
      width: 200,

      filter: {
        type: "Excel",
        itemTemplate: data => parseFloat(data.saascorenormal ?? 0).toFixed(2),
      },
      template: data => parseFloat(data.saascorenormal ?? 0).toFixed(2)
    })
    columns.push({
      field: "costbenefit",
      headerText: "Benefit / Cost Ratio",
      width: 200,
      filter: {
        type: "Excel",
        itemTemplate: data => parseFloat(data.costbenefit ?? 0).toFixed(2)
      },
      template: data => parseFloat(data.costbenefit ?? 0).toFixed(2)
    })

    setColumns(columns)
  }

  return (
    <React.Fragment>
      <div
        style={{
          height: "65vh",
          marginBotton: "0px",
          overflowY: "auto",
          overflowX: "auto",
        }}
      >
        {columns.length > 0 && data.length > 0 && (
          <SyncfusionGrid columns={columns} data={data} />
        )}
      </div>
    </React.Fragment>
  )
}

export default AlternativeRatingsGrid
